import { Box, Center } from '@chakra-ui/react'

const FooterOverlay: React.FC<{
  darkBackgroundOnFocus?: boolean
  children: React.ReactNode | React.ReactNode[]
}> = ({ darkBackgroundOnFocus, children }) => {
  if (darkBackgroundOnFocus) {
    return (
      <Box
        position="fixed"
        bottom={0}
        left={0}
        right={0}
        zIndex="overlay"
        _focusWithin={{ top: 0, bg: 'rgba(0, 0, 0, 0.5)' }}
        transition="background 0.5s ease"
        bg="transparent"
      >
        <Center
          pt={5}
          px={6}
          pb={10}
          backgroundColor="white"
          position="absolute"
          bottom={0}
          w="100%"
          boxShadow="md"
        >
          {children}
        </Center>
      </Box>
    )
  }

  return (
    <Center
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      zIndex="overlay"
      boxShadow="md"
      backgroundColor="white"
    >
      <Center
        pt={5}
        px={{ base: 6, lg: 0 }}
        pb={10}
        w={{ base: 'full', lg: 552 }}
      >
        {children}
      </Center>
    </Center>
  )
}

export default FooterOverlay
